import React from 'react';

import { Box, Text } from '@betterment/samba-react';

import FourOhOneKAccountRow from './FourOhOneKAccountRow';

import { DeferralSetting, DeferralSettings } from '../data';

const FourOhOneKByEmployer: React.FC<{
  deferralSettings: DeferralSettings;
  shouldShowHelpText: boolean;
}> = ({ deferralSettings, shouldShowHelpText }) => {
  return (
    <>
      <Box css={{ marginBottom: '1.6rem', marginTop: '3.2rem' }}>
        <Text variant="text100" css={{ fontWeight: 600 }}>
          {deferralSettings[0].employer.name}
        </Text>
      </Box>
      {deferralSettings?.map((deferralSetting: DeferralSetting) => (
        <FourOhOneKAccountRow
          deferralSetting={deferralSetting}
          shouldShowHelpText={shouldShowHelpText}
          key={deferralSetting.id}
        />
      ))}
    </>
  );
};

export default FourOhOneKByEmployer;
